define([
    './BaseUtil',
    './StateUtil'
], (BaseUtils, StateUtils)=> {
    return angular.module('edge.platform.util', [])

        .factory('BaseUtils', BaseUtils)
        .factory('StateUtils', StateUtils);
});



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/util/module.js